/** @app — application layer; owned per-fork (LMS / OTT). See PLATFORM_FILES.md. */
import type { ReactNode } from 'react';

interface SectionShellProps {
  /** Scroll-anchor id (also used as the tab panel's content id). */
  id?: string;
  title?: string;
  subtitle?: string;
  children: ReactNode;
}

export function SectionShell({ id, title, subtitle, children }: SectionShellProps) {
  return (
    <section className="cd-section" id={id}>
      {title && <h2 className="cd-section-title">{title}</h2>}
      {subtitle && <p className="cd-section-subtitle">{subtitle}</p>}
      {children}
    </section>
  );
}
